import { createVuetify } from "vuetify";

import "vuetify/dist/vuetify.css";

// Translation provided by Vuetify (javascript)
import { it, en } from "vuetify/locale";

const vuetify = createVuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {},
    },
  },
  locale: {
    locale: "en",
    fallback: "en",
    messages: { en, it },
  },
});

export default vuetify;
